import { render, staticRenderFns } from "./TrophyForm.vue?vue&type=template&id=0b7238a7&scoped=true&"
import script from "./TrophyForm.vue?vue&type=script&lang=js&"
export * from "./TrophyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7238a7",
  null
  
)

export default component.exports